/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A negative result means the value decreased rather than increased. Use the percentage decrease calculator to express that drop as a positive number.`)
};

const es_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un resultado negativo significa que el valor disminuyó en lugar de aumentar. Usa la calculadora de disminución porcentual para expresar esa caída como un número positivo.`)
};

const de_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein negatives Ergebnis bedeutet, dass der Wert gesunken statt gestiegen ist. Nutze den Rechner für den prozentualen Rückgang, um diesen Rückgang als positive Zahl auszudrücken.`)
};

const nl_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een negatief resultaat betekent dat de waarde is gedaald in plaats van gestegen. Gebruik de calculator voor percentagedaling om die daling als een positief getal uit te drukken.`)
};

const fr_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un résultat négatif signifie que la valeur a diminué plutôt qu'augmenté. Utilisez le calculateur de diminution en pourcentage pour exprimer cette baisse sous forme de nombre positif.`)
};

const it_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un risultato negativo significa che il valore è diminuito invece di aumentare. Usa il calcolatore di calo percentuale per esprimere quella diminuzione come numero positivo.`)
};

const pt_br2_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um resultado negativo significa que o valor diminuiu em vez de aumentar. Use a calculadora de diminuição percentual para expressar essa queda como um número positivo.`)
};

const pt_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um resultado negativo significa que o valor diminuiu em vez de aumentar. Use a calculadora de diminuição percentual para expressar essa queda como um número positivo.`)
};

const ja_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果がマイナスになる場合、値は増加ではなく減少したことを意味します。その下落を正の数で表すには、パーセント減少計算機を使ってください。`)
};

const zh_pct_increase_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`负数结果表示数值是减少而非增长。请使用百分比减少计算器，将降幅表达为正数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq2_a", locale)
	if (locale === "en") return en_pct_increase_faq2_a(inputs)
	if (locale === "es") return es_pct_increase_faq2_a(inputs)
	if (locale === "de") return de_pct_increase_faq2_a(inputs)
	if (locale === "nl") return nl_pct_increase_faq2_a(inputs)
	if (locale === "fr") return fr_pct_increase_faq2_a(inputs)
	if (locale === "it") return it_pct_increase_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq2_a(inputs)
	if (locale === "pt") return pt_pct_increase_faq2_a(inputs)
	if (locale === "ja") return ja_pct_increase_faq2_a(inputs)
	return zh_pct_increase_faq2_a(inputs)
};